function parseOpts(value) {
	if (value === false) return { disabled: true }
	if (!value || typeof value !== 'object') return {}
	return value
}

function isInteractive(target) {
	return !!(target && target.closest && target.closest(
		'input, textarea, select, button, a, .el-input, .el-select, .el-input-number, .el-dialog__headerbtn, .good_dialog_close, .cart_title_submit'
	))
}

function getDialog(wrapper) {
	return wrapper && wrapper.querySelector ? wrapper.querySelector('.el-dialog') : null
}

function resetDialog(dialog) {
	if (!dialog) return
	dialog.style.removeProperty('left')
	dialog.style.removeProperty('top')
	dialog.style.removeProperty('right')
	dialog.style.removeProperty('bottom')
	dialog.style.removeProperty('position')
	dialog.style.removeProperty('transform')
	dialog.style.removeProperty('margin')
}

function pinDialog(dialog) {
	const rect = dialog.getBoundingClientRect()
	dialog.style.setProperty('margin', '0', 'important')
	dialog.style.position = 'absolute'
	dialog.style.left = rect.left + 'px'
	dialog.style.top = rect.top + 'px'
	dialog.style.right = 'auto'
	dialog.style.bottom = 'auto'
	dialog.style.transform = 'none'
	return rect
}

export default {
	bind(el, binding) {
		el._dialogDragOpts = parseOpts(binding.value)
		const wrapper = el
		const state = {
			dragging: false,
			startX: 0,
			startY: 0,
			origLeft: 0,
			origTop: 0,
			dialog: null,
		}

		function onMove(e) {
			if (!state.dragging || !state.dialog) return
			const dialog = state.dialog
			const minVisible = 48
			let left = state.origLeft + (e.clientX - state.startX)
			let top = state.origTop + (e.clientY - state.startY)
			left = Math.min(Math.max(left, minVisible - dialog.offsetWidth), window.innerWidth - minVisible)
			top = Math.min(Math.max(top, 0), window.innerHeight - minVisible)
			dialog.style.left = left + 'px'
			dialog.style.top = top + 'px'
		}

		function onUp() {
			state.dragging = false
			document.removeEventListener('mousemove', onMove)
			document.removeEventListener('mouseup', onUp)
			document.body.style.removeProperty('user-select')
			document.body.style.removeProperty('cursor')
		}

		function onDown(e) {
			const opts = el._dialogDragOpts || {}
			if (opts.disabled) return
			if (e.button !== 0) return
			const dialog = getDialog(wrapper)
			if (!dialog) return
			const handle = dialog.querySelector(opts.handle || '.el-dialog__header')
			if (!handle || !handle.contains(e.target)) return
			if (isInteractive(e.target)) return
			e.preventDefault()
			const rect = pinDialog(dialog)
			state.dialog = dialog
			state.dragging = true
			state.startX = e.clientX
			state.startY = e.clientY
			state.origLeft = rect.left
			state.origTop = rect.top
			document.body.style.userSelect = 'none'
			document.body.style.cursor = 'move'
			document.addEventListener('mousemove', onMove)
			document.addEventListener('mouseup', onUp)
		}

		function onVisibleChange() {
			if (state.dragging) return
			const hidden = window.getComputedStyle(wrapper).display === 'none'
			if (!hidden) resetDialog(getDialog(wrapper))
		}

		const observer = new MutationObserver(onVisibleChange)
		observer.observe(wrapper, { attributes: true, attributeFilter: ['style', 'class'] })
		wrapper.addEventListener('mousedown', onDown)
		el._dialogDrag = { onDown, onMove, onUp, observer, wrapper }
	},
	update(el, binding) {
		el._dialogDragOpts = parseOpts(binding.value)
	},
	unbind(el) {
		const rec = el._dialogDrag
		if (!rec) return
		rec.wrapper.removeEventListener('mousedown', rec.onDown)
		document.removeEventListener('mousemove', rec.onMove)
		document.removeEventListener('mouseup', rec.onUp)
		if (rec.observer) rec.observer.disconnect()
		el._dialogDrag = null
		el._dialogDragOpts = null
	},
}
